module.exports = __webpack_public_path__ + "static/Lato-Regular-27bd77b9162d388cb8d4c4217c7c5e2a.woff";